@if (bannerData$ | async; as data) { @if (data) {
<ngb-carousel [interval]="this.intervalTime">
  @for (slide of data; track $index) {
  <ng-template ngbSlide>
    <div [ngClass]="activeCountry$ | async">
      @if (slide.media) {
      <cx-media [container]="(slide?.media)['desktop']" class="responsive-desktop" removeImageTitleAttr></cx-media>
      } @if (slide.media) {
      <cx-media [container]="(slide?.media)['tablet']" class="responsive-tablet" removeImageTitleAttr></cx-media>
      } @if (slide.media) {
      <cx-media
        [container]="(slide?.media)['mobile']"
        class="responsive-mobile"
        (click)="redirectTo(slide.urlLink)"
        removeImageTitleAttr
      ></cx-media>
      }
    </div>
    <div class="carousel-caption">
      @if ( ((slide.title | json) !== '{}' && slide.title !== null && !!slide.title) || ((slide.title | json) !== '{}'
      && slide.description !== null && !!slide.description) || ((slide.urlLink | json) !== '{}' && slide.urlLink !==
      null && !!slide.urlLink) ) {
      <div class="banner-texts">
        @if ((slide.title | json) !== '{}') {
        <h3>{{ slide.title }}</h3>
        } @if ((slide.description | json) !== '{}') {
        <p class="d-none d-md-block">{{ slide.description }}</p>
        } @if (checkUrl(slide.urlLink)) {
        <button mat-flat-button class="primary-btn d-none d-md-block" (click)="redirectTo(slide.urlLink)">
          {{ 'banner.goTo' | cxTranslate }} {{ slide.title | uppercase }}
        </button>
        }
      </div>
      }
    </div>
  </ng-template>
  }
</ngb-carousel>
} }
